import React, { useState } from 'react'
import FloatingButton from '../../components/UI/FloatingButton'
import LocationTable from './LocationTable'
import { IDeckGame, IDeckStatus } from './types'
import { CloseOutlined } from '@ant-design/icons';
import { useAuth } from '../../context/AuthProvider/useAuth'
import { closeDecks } from '../../services/deckStatus'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import List from '../../components/List'


function DecksLists(props: { decks: IDeckStatus[], generatedAt: string}) {
  const loading = useLoading()
  const {canEdit} = useAuth()
  const [disabledButton, setDisabledButton] = useState(true)
  const [sentValues, setSentValues] = useState<{locationId: string, gameId: string}[]>([])

  const onCloseDecks = async () => {
    const container = document.querySelector('.decks-lists__lists')
    const inputs: any = container!.querySelectorAll('input[type="checkbox"]')
    if(!inputs || inputs.length === 0) return
    loading.addLoading()
    const payload: {locationId: string, gameId: string}[] = []
    const checkedInputs: any = []
    inputs.forEach((input: any) => {
      if(input.checked && input.dataset.location) {
        checkedInputs.push(input)
        payload.push({locationId: input.dataset.location, gameId: input.id})
      }
    })
    const res = await closeDecks(payload)
    if (res) {
      setSentValues(prev => [...prev, ...payload])
      setDisabledButton(true)
    }
    loading.removeLoading()
  }

  const checkBodyChange = () => {
    const container = document.querySelector('.decks-lists__lists')
    const inputs: any = container!.querySelectorAll('input[type="checkbox"]')
    let checked = true
    if(inputs && inputs.length > 0) {
      inputs.forEach((input: any) => {
        if(input.checked) {
          checked = false
        }
      })
    }
    checked !== disabledButton && setDisabledButton(checked)
  }
  
  return (
    <div className="decks-lists">
      <div className="decks-lists__header">
        Pilot Gaming - generated at {props.generatedAt}
      </div>
      <div className="decks-lists__lists">
        {props.decks.map((deck) => (
          <LocationTable
            sentValues={sentValues}
            resetSentValues={() => setSentValues([])}
            id={deck.location.locationId} 
            name={deck.location.locationName} 
            listGames={deck.games || []}
            checkBodyChange={checkBodyChange}
            total={deck.total}
          />
        ))}
        {props.decks.length === 0 && (
          <List
            columns={[
              {
                title: 'Form',
                dataIndex: 'form',
                key: 'form',
                render: (value: string) => value,
                width: 50
              },
              {
                title: 'Title',
                dataIndex: 'title',
                key: 'title',
                render: (value: string) => value,

                width: 150
              },
              {
                title: 'Opened Time',
                dataIndex: 'openedTime',
                key: 'openedTime',
                render: (value: string) => value,

                width: 200
              },
              {
                title: 'Serial',
                dataIndex: 'serial',
                key: 'serial',
                render: (value: string) => value,

                width: 130
              },
              {
                title: 'Tickets',
                dataIndex: 'tickets',
                key: 'tickets',
                render: (value: string) => value,

                width: 130
              },
              {
                title: 'Payout',
                dataIndex: 'payout',
                key: 'payout',
                render: (value: string) => value && value + '%',

                width: 100
              },
              {
                title: 'Total Ticket Cost',
                dataIndex: 'totalTicketCost',
                key: 'totalTicketCost',
                render: (value: number) => value !== 0 && value,
                width: 150
              },
              {
                title: 'Total Ticket Prizes',
                dataIndex: 'totalTicketPrizes',
                key: 'totalTicketPrizes',
                render: (value: number) => value !== 0 && value ,

                width: 150
              },
              {
                title: 'Current Total Wager',
                dataIndex: 'currentTotalWager',
                key: 'currentTotalWager',
                render: (value: string) => value,

                width: 150
              },
              {
                title: 'Current Total Won',
                dataIndex: 'currentTotalWon',
                key: 'currentTotalWon',
                render: (value: string) => value,
                width: 150
              },
              {
                title: 'Actual Payout',
                dataIndex: 'actualPayout',
                key: 'actualPayout',
                render: (value: string) => value,
                width: 150
              },
              {
                title: 'Prizes Won',
                dataIndex: 'prizesWon',
                key: 'prizesWon',
                render: (value: number) => value,
                width: 100
              },
              {
                title: 'Remaining Ticket Pct',
                dataIndex: 'remainingTicketPct',
                key: 'remainingTicketPct',
                render: (value: number) => value !== 0 && value,
                width: 150
              },
              {
                title: 'Inventory Left',
                dataIndex: 'inventoryLeft',
                key: 'inventoryLeft',
                render: (value: string) => value,
                width: 150
              },
              {
                title: 'Actions',
                dataIndex: '',
                key: 'checkBox',
                render: (value: IDeckGame, index: number) => <input />,
                width: 150
              },
            ]}
            rows={[]} 
          />  
        )}
      </div>
      <FloatingButton
        text={'Close Decks'}
        onClick={onCloseDecks}
        disabled={disabledButton }
      />
    </div>
  )
}

export default DecksLists